import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import RegistrationFormService from '../services/RegistrationFormService';
import ValidateableDropdownField from "./ValidateableDropdownField";

class ProvinceDropdown extends Component {

  validateValue = (value) => {
    return RegistrationFormService.validateProvinceTerritory(value);
  };

  render() {
    return (
        <React.Fragment>
         <ValidateableDropdownField
             fieldLabel={this.props.fieldLabel}
             validationFunction={this.validateValue}
             onChange={this.props.onChange}
             options="provinces"
             showErrors={this.props.showErrors}
         />
        </React.Fragment>
    )
  }
}

ProvinceDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  fieldLabel: PropTypes.string,
  showErrors: PropTypes.bool
};

export default ProvinceDropdown;